let base_path = `/api/v2/rcs-orders`

export default {

    fetchRcsOrders(){
        return axios.get(`${base_path}`)
    },

    createRcsOrder(data) {
        return axios.post(`${base_path}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
